// PROJECT IMPORTS
import ConfirmationModal from "./ConfirmationModal";
import Cookies from "js-cookie";
import DOMPurify from "dompurify";

// TYPES
interface WelcomeModalProps {
  visible: boolean;
  isLoading?: boolean;
  onCancelClick: () => void;
  onDoneClick: () => void;
  welcomeMessage?: string;
}


const WelcomeModal = (props: WelcomeModalProps) => {
  const {
    visible = false,
    isLoading = false,
    onCancelClick,
    welcomeMessage = process.env.REACT_APP_WELCOME_MESSAGE || "",
  } = props;

  const [title] = welcomeMessage.split(". ").filter(Boolean);
  const sanitizedMessage = DOMPurify.sanitize(welcomeMessage);

  const handleDoneClick = () => {
    Cookies.set("showWelcomeModal", "false", { expires: 365 });
    onCancelClick?.();
  };

  return (
      <ConfirmationModal
        isLoading={isLoading}
        open={visible}
        onCancel={handleDoneClick}
        onConfirm={onCancelClick}
        okText="Close"
        cancelText="Don’t show again"
        title={title}
        icon={false}
      >
        <div>
          <div dangerouslySetInnerHTML={{ __html: sanitizedMessage }}></div>
        </div>
      </ConfirmationModal>
  );
};

export default WelcomeModal;
